import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import React from 'react';
import { Card, CardHeader, Col, Row, TabContent, TabPane } from 'reactstrap';
import MainEngineComponent from './partials/MainEngineComponent';
import AuxEngineComponent from './partials/AuxEngineComponent';
import CountersFlowmetersComponent from './partials/CountersFlowmetersComponent';
import { EventPrecedence } from 'shared/constants';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface EconAddInformationType {
    toggleDynamicTabs: any
    setErrorMessage: any,
    toggleAddEconTab: (value: number) => void
    editReportBool: boolean
}

const EconAddInformation = ({
    toggleDynamicTabs,
    setErrorMessage,
    toggleAddEconTab,
    editReportBool
}: EconAddInformationType) => {
    const { activeAddEconTab } = useEditReport();
    /** State variables start*/
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    /** State variables end*/

    const isCurrentReportNoonReport = () => {
        return currentVesselReport?.event_precedence_id === EventPrecedence.NOON ||
            currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report";
    }

    return (
        <Card className='p-0 mb-0 border-0'>
            <CardHeader className='p-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Additional Information</h4>
                            <p className="card-title-desc pos-start">All readings since last report</p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <TabContent activeTab={activeAddEconTab} className="tabHeight">
                    <TabPane tabId={isCurrentReportNoonReport() ? 1 : 0}>
                        <MainEngineComponent
                            toggleAddTab={toggleAddEconTab}
                            toggleDynamicTabs={toggleDynamicTabs}
                            setErrorMessage={setErrorMessage}
                            activeAddEconTab={activeAddEconTab}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={isCurrentReportNoonReport() ? 2 : 0}>
                        <AuxEngineComponent
                            toggleAddTab={toggleAddEconTab}
                            setErrorMessage={setErrorMessage}
                            activeAddEconTab={activeAddEconTab}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={isCurrentReportNoonReport() ? 3 : 1}>
                        <CountersFlowmetersComponent
                            toggleAddTab={toggleAddEconTab}
                            toggleDynamicTabs={toggleDynamicTabs}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </Card>
    )
}

export default EconAddInformation